/** Public IP as seen from the internet (fallback when API only receives loopback behind proxy). */
export async function getClientPublicIp(timeoutMs = 4000) {
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    const res = await fetch("https://api.ipify.org?format=json", {
      signal: controller.signal,
    });
    clearTimeout(timer);
    if (!res.ok) return null;
    const data = await res.json();
    const ip = typeof data?.ip === "string" ? data.ip.trim() : "";
    return ip || null;
  } catch {
    return null;
  }
}
